/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'reset': {
    width: 211.719,
    height: 200,
    viewBox: '0 0 1084 1024',
    data: '<defs/><path pid="0" d="M788.804 977.5a503.543 503.543 0 00162.507-119.862 509.687 509.687 0 00103.781-174.313 515.048 515.048 0 0028.55-194.069 514.385 514.385 0 00-45.536-190.816 508.663 508.663 0 00-118.658-164.194A501.676 501.676 0 00554.922.53a503.905 503.905 0 00-351.336 166 509.808 509.808 0 00-94.565 150.16L0 290.188l45.174 154.014L90.41 598.217l109.382-116.61 109.382-116.55-103.058-24.936a411.388 411.388 0 0169.99-106.612 405.846 405.846 0 01576.907-25.96c166.181 153.593 177.626 415.002 25.66 582.87a406.087 406.087 0 01-577.028 25.9l-66.316 73.302a502.098 502.098 0 00364.708 133.837A499.387 499.387 0 00788.804 977.5z"/>'
  }
})
